/*================ vendors ====================*/

window.addEventListener('DOMContentLoaded', function() {
(function($) {
  const $carousel = $('[data-grid-carousel]');		
  const prevSlick = '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 32 32"><path fill="#ffffff" d="M24.333 28.205l-1.797 1.684L7.666 16l14.87-13.889 1.797 1.675L11.269 16z"/></svg></button>';
  const nextSlick = '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 32 32"><path fill="#ffffff" d="M7.667 3.795l1.797-1.684L24.334 16 9.464 29.889l-1.797-1.675L20.731 16z"/></svg></button>'

  $(document).ready(function() {
   
	

	$carousel
	  .on('init reInit setPosition breakpoint', function(event, slick) {
	    handleCarouselUpdate(event, slick);
	  })
	  .slick({
	    slidesToShow: 4,
	    slidesToScroll: 1,
	    infinite: false,
	    arrows: true,
	    dots: false,
	    prevArrow: prevSlick,
        nextArrow: nextSlick,  
	    responsive: [
	      {
	        breakpoint: 1024,
	        settings: {
	          slidesToShow: 3
	        }
	      },
	      {
	        breakpoint: 768,
	        settings: {
	          slidesToShow: 2
	        }
	      },
	      {
	        breakpoint: 480,
	        settings: {
	          slidesToShow: 2
	        }
	      }
	    ]
	  });
  });


function handleCarouselUpdate(event, slick) {
  //console.log('Slides showing:', slick.options.slidesToShow);
  //console.log('Current breakpoint:', slick.activeBreakpoint);
  //$('.productGridSection .productGrid .slick-active .customCard .card__information').matchHeight();
  $('.productGridSection .productGrid  .card__information').height('auto');
	$('.productGridSection .productGrid .slick-active.customCard .card__information').matchHeight();
}


// optional window resize listener
let resizeTimer;
$(window).on('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    $carousel.slick('setPosition'); // forces slick to recalc layout
  }, 600);
});


 
})(jQuery);
});